export const LAB_ACCESS_LOST = 'kalibr:lab-access-lost';

/** Lab authentication is independent of the app's localStorage identity. */
export async function labFetch(input: string, init?: RequestInit): Promise<Response> {
  const response = await fetch(input, { ...init, credentials: 'same-origin' });
  if (response.status === 401 || response.status === 403) window.dispatchEvent(new Event(LAB_ACCESS_LOST));
  return response;
}
